<div class="modal-content">
  <apm-section-title icon="t_search" title="{{ '445220' | apmTranslate }}"></apm-section-title>
  <div class="d-flex classes-height">
    @if (groupedClasses$ | async; as groupedClasses) {
      @for (group of groupedClasses | keyvalue; track group.key; let isLast = $last) {
        <div class="w-100 me-3">
          @for (c of group.value; track c.id) {
            <apm-list-tile class="mb-2" (listTileClick)="filterSelected(c)">
              {{ c.description ? c.description : (c.descriptionId | apmTranslate) }}
            </apm-list-tile>
          }
          @if (custom && isLast) {
            <apm-list-tile class="mb-2" (listTileClick)="customSelected()">
              {{ '445221' | apmTranslate }}
            </apm-list-tile>
            <apm-list-tile class="mb-2" (listTileClick)="utaSelected()">
              {{ '445222' | apmTranslate }}
            </apm-list-tile>
          }
        </div>
      }
    }
  </div>
</div>
